import PropTypes from 'prop-types';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';

// Keep the backend above route changes and Suspense so pages and drawers share it.
export default function DragDropProvider({ children }) {
  return <DndProvider backend={HTML5Backend}>{children}</DndProvider>;
}

DragDropProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
